import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({
    name: 'spHtmlToText',
    standalone: true,
})
export class HtmlToTextPipe implements PipeTransform {
    transform(value: string): string {
        const temp = document.createElement('div');
        temp.innerHTML = value;
        return temp.textContent || temp.innerText || '';
    }
}
